module.exports = __webpack_public_path__ + "static/slidecard02_03-24e5b83c193d8f1c49fd94ee2ccc7384.png";